import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetch personal KPI metrics for the current user (or viewAs user for QA testing)
 */
export const useFetchMyKpis = (viewAs = null, opts = {}) => {
  return useQuery(
    ['my-kpis', { viewAs }],
    async () => {
      const params = {};
      if (viewAs) {
        params.viewAs = viewAs;
      }
      const res = await axios.get('/my-kpis', { params });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      ...opts,
    },
  );
};

/**
 * Fetch list of all claims managers (for QA testing dropdown)
 * TEMP: Remove after QA is complete
 */
export const useFetchClaimsManagers = (opts = {}) => {
  return useQuery(
    ['claims-managers-list'],
    async () => {
      const res = await axios.get('/my-kpis/managers');
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      ...opts,
    },
  );
};
